/**
 * Route for `influencer-channels`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { InfluencerChannelsPage } from "../features/influencer-channels/InfluencerChannelsPage";

export const influencerChannelsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/influencer-channels",
	component: InfluencerChannelsPage,
});

export default influencerChannelsRoute;
